/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEnrichedInstrumentLink} from '../api'

 export const useQueryGetEnrichedInstrumentLink = createReactQueryHook('getEnrichedInstrumentLink', getEnrichedInstrumentLink)
